// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"b1ad480328608b71","5763":"6855f215ba7ce552","7222":"94bb6ea8d1bc2f11","7937":"e389357923df8fce"}[chunkId] + ".js";
};